import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { ContentCard } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { selectionIsAssignable } from '../../../selectors/reservationModuleState/reservationSelection';
import { ResourceAssignTable } from '../../ResourcesSection';

interface OwnProps {
    scope: string;
}
interface StateProps {
    isAssignable: boolean;
}
type Props = OwnProps & StateProps;

const ResourceAssignTableCard = ({ isAssignable, scope }: Props) => {
    if (!isAssignable) {
        return null;
    }

    return (
        <ContentCard title={<LocalizedText textKey={TextKey.ResourcePlural} />}>
            <ResourceAssignTable scope={scope} />
        </ContentCard>
    );
};
export default connect<StateProps, null, OwnProps, ApplicationState>((state, { scope }) => ({
    isAssignable: selectionIsAssignable(state, { scope }),
}))(ResourceAssignTableCard);
